import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import { appApiEndpoint } from "environment";
import { compose } from "redux";
import io from "socket.io-client";
import withUserProp from "hocs/withUserProp";

// Create a context
const SocketContext = createContext(null);

// Custom hook to use the socket context
export const useSocket = () => {
  return useContext(SocketContext);
};

// Provider component
const SocketProvider = ({ user, children }) => {
  const socketRef = useRef(null); // 👈 useRef instead of state
  const [eventLog, setEventLog] = useState([]); // Store all events

  const onConnect = () => {
    console.log("Socket connected!");
  };

  useEffect(() => {
    const cleanupSocket = () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      setEventLog([]);
    };

    if (!user || user.type !== 2) {
      console.log(
        "User is missing or admin about to impersonate — closing socket if any"
      );
      cleanupSocket();
      return;
    }

    const socketInstance = io(appApiEndpoint, {
      path: "/socket.io",
      withCredentials: true,
      query: {
        employerId: user.employerId,
      },
      reconnectionDelay: 2000, // Start with a 2s delay
      reconnectionDelayMax: 60000, // Max delay of 60s
    });
    socketRef.current = socketInstance;

    socketInstance.onAny((eventName, ...args) => {
      console.log(`Received event: ${eventName}`, args);
      // Store the event in the log but limit the log length to 10
      setEventLog((prevLog) => {
        const newLog = [...prevLog, { eventName, args }];
        return newLog.slice(Math.max(newLog.length - 10, 0));
      });
    });
    socketInstance.on("connect", onConnect);

    return cleanupSocket;
  }, [user]);

  const clearEventLog = () => {
    setEventLog([]);
  };

  console.log("The eventLog is: ", eventLog);

  return (
    <SocketContext.Provider
      value={{ socket: socketRef.current, eventLog, clearEventLog }}
    >
      {children}
    </SocketContext.Provider>
  );
};

const enhance = compose(withUserProp);

export default enhance(SocketProvider);
